module.exports = __webpack_public_path__ + "img/qualidade.13d1b242.png";